export const UPDATE_MODEL_MANAGEMENT_STATE = "UPDATE_MODEL_MANAGEMENT_STATE"
export const MT_LOAD_DEPLOYMENT_LOGS= "MT_LOAD_DEPLOYMENT_LOGS"